interface PaginationProps {
    currentPage: number;
    totalPages: number;
    handlePageChange: (page: number) => void;
}


const Pagination: React.FC<PaginationProps> = (props: PaginationProps) => {
    const { currentPage, totalPages, handlePageChange } = props;
    return (
        <div className="flex justify-center items-center mt-6 mb-4">
            <div className="flex items-center space-x-1">
                <button
                    onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`px-3 py-1 rounded-md ${currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-100'}`}
                >
                    <span className="sr-only">Previous</span>
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                </button>

                {/* First page */}
                {currentPage > 2 && (
                    <button
                        onClick={() => handlePageChange(1)}
                        className={`px-3 py-1 rounded-md ${currentPage === 1 ? 'bg-[#EC5306] text-white' : 'text-gray-700 hover:bg-gray-100'}`}
                    >
                        1
                    </button>
                )}

                {/* Ellipsis if needed */}
                {currentPage > 3 && (
                    <span className="px-3 py-1">...</span>
                )}

                {/* Previous page if not first */}
                {currentPage > 1 && (
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        className="px-3 py-1 rounded-md text-gray-700 hover:bg-gray-100"
                    >
                        {currentPage - 1}
                    </button>
                )}

                {/* Current page */}
                <button
                    className="px-3 py-1 rounded-md bg-[#EC5306] text-white"
                >
                    {currentPage}
                </button>

                {/* Next page if not last */}
                {currentPage < totalPages && (
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        className="px-3 py-1 rounded-md text-gray-700 hover:bg-gray-100"
                    >
                        {currentPage + 1}
                    </button>
                )}

                {/* Ellipsis if needed */}
                {currentPage < totalPages - 2 && (
                    <span className="px-3 py-1">...</span>
                )}

                {/* Last page if not current or next */}
                {currentPage < totalPages - 1 && (
                    <button
                        onClick={() => handlePageChange(totalPages)}
                        className="px-3 py-1 rounded-md text-gray-700 hover:bg-gray-100"
                    >
                        {totalPages}
                    </button>
                )}

                <button
                    onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1 rounded-md ${currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-100'}`}
                >
                    <span className="sr-only">Next</span>
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Pagination